import { ReferencedEntry } from 'contentful';
import React from 'react';

import { ContentType, LinkSet, NavigationItem } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ContentLink } from 'src/components/ContentLink/ContentLink';
import { getContentType } from 'src/utils/CloverdotcomEntryUtil';
import { getField, getSys, isEntry } from 'src/utils/EntryUtil';
import { testAttribute } from 'src/utils/Serenity';

import { LinkSetTitle } from './LinkSetTitle/LinkSetTitle';

export const QA_TEST_PREFIX = 'header-appbar';

let testAttributeCounter = 0;

export function getDataTestAttributeValue(entry?: ReferencedEntry<LinkSet>) {
  const title = getField(entry as ReferencedEntry<LinkSet>, 'title');

  return testAttribute(
    QA_TEST_PREFIX,
    'item',
    title || getSys(entry, 'id') || testAttributeCounter++
  );
}

export interface INavTitle extends React.ButtonHTMLAttributes<HTMLElement> {
  entry?: ReferencedEntry<NavigationItem>;
  expanded?: boolean;
  showCaret?: boolean;
  isMobile?: boolean;
}

export const NavTitle = React.forwardRef<HTMLButtonElement | HTMLAnchorElement | HTMLSpanElement, INavTitle>(({
  entry, expanded, showCaret, isMobile, ...props
}, ref) => {
  if (!isEntry(entry)) return null;

  // tslint:disable-next-line:no-string-literal
  delete props['ref'];

  const dataTestValue = getDataTestAttributeValue(entry);

  switch (getContentType(entry)) {
    case ContentType.LINK_SET:
      return (
        <LinkSetTitle
          entry={entry}
          expanded={expanded}
          showCaret={showCaret}
          isMobile={isMobile}
          {...props}
          ref={ref}
          data-test={dataTestValue}
        />
      );
    default:
      return (
        <ContentLink
          entry={entry}
          {...props}
          innerRef={ref as React.Ref<HTMLAnchorElement>}
          data-test={dataTestValue}
        />
      );
  }
});

export type NavTitle = typeof NavTitle;
